import { BrowserModule } from '@angular/platform-browser';
import { Component, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CustomFormsModule } from 'ng2-validation';

import { AppComponent } from './app.component';
import { Router } from './app.routes';

import { AppSharedModule } from './app.shared.module';
import { QuestionsComponent } from './questions/questions.component';
import { VotesComponent } from './votes/votes.component';
import { QuizzComponent } from './quizz/quizz.component';
import { TagCloudComponent } from './tagcloud/tagcloud.component';
import { LoaderComponent } from './loader/loader.component';

import { environment as config } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    QuestionsComponent,
    VotesComponent,
    TagCloudComponent,
    QuizzComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    CustomFormsModule,
    Router,
    AppSharedModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/app.module.ts